import React, { useState } from "react";
import Navbar from "../components/Navbar";
import MemberCard from "../components/MemberCard";
import api from "../lib/api";
import { toast } from "sonner";
import { NbButton, NbInput } from "../components/nb";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [q, setQ] = useState("");
  const [members, setMembers] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const run = async (e) => {
    e?.preventDefault();
    setLoading(true); setSearched(true);
    try {
      const { data } = await api.get("/members", { params: q ? { q } : {} });
      setMembers(data);
    } catch { toast.error("Search failed."); }
    finally { setLoading(false); }
  };

  const like = async (m) => {
    try {
      const { data } = await api.post(`/like/${m.id}`);
      setMembers((p) => p.map((x) => x.id === m.id ? { ...x, liked: data.liked } : x));
      if (data.matched) toast.success(`It's a match with ${m.name}! 🎉`);
    } catch {}
  };
  const fav = async (m) => {
    try {
      const { data } = await api.post(`/favorite/${m.id}`);
      setMembers((p) => p.map((x) => x.id === m.id ? { ...x, favorited: data.favorited } : x));
    } catch {}
  };

  return (
    <div className="min-h-screen grain">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-head font-black text-4xl tracking-tighter mb-1">Search</h1>
        <p className="text-gray-600 font-medium mb-6">Find people by name, bio, occupation or interests.</p>
        <form onSubmit={run} className="flex gap-3 mb-8 max-w-2xl">
          <NbInput data-testid="search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search keywords..." />
          <NbButton type="submit" data-testid="search-submit"><SearchIcon className="w-4 h-4" /> Search</NbButton>
        </form>

        {loading ? (
          <div className="text-center py-20 font-head font-bold uppercase">Searching...</div>
        ) : searched && members.length === 0 ? (
          <div className="bg-white nb-border nb-shadow p-10 text-center font-medium">No results found.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {members.map((m) => <MemberCard key={m.id} m={m} onLike={like} onFav={fav} />)}
          </div>
        )}
      </div>
    </div>
  );
}
